import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';

import { UserProfileDataType } from '../common/types';

export interface PreviewWithDataContextState {
  canRefreshPreview: boolean;
  dataFeedData: string;
  dataFeedDataIsValid: boolean;
  isDataFeedDataEmpty: boolean;
  isLoadingDataFeeds: boolean;
  isLoadingUserData: boolean;
  isUserDataEmpty: boolean;
  onLoadDataFeeds: NoOp;
  onLoadUserData: (str: string, userDataType: UserProfileDataType) => void;
  setDataFeedData: (str: string) => void;
  setUserData: (str: string) => void;
  userData: string;
  userDataIsValid: boolean;
  isUserDataDirty: boolean;
  setIsUserDataDirty: (bool: boolean) => void;
}

export const INITIAL_PREVIEW_WITH_DATA_CONTEXT_STATE: PreviewWithDataContextState = {
  canRefreshPreview: true,
  dataFeedData: '{}',
  dataFeedDataIsValid: true,
  isDataFeedDataEmpty: true,
  isLoadingDataFeeds: false,
  isLoadingUserData: false,
  isUserDataEmpty: true,
  onLoadDataFeeds: noop,
  onLoadUserData: noop,
  setDataFeedData: noop,
  setUserData: noop,
  userData: '{}',
  userDataIsValid: true,
  isUserDataDirty: false,
  setIsUserDataDirty: noop,
};

export const PreviewWithDataContext = createContext<PreviewWithDataContextState>(
  INITIAL_PREVIEW_WITH_DATA_CONTEXT_STATE,
);

export const usePreviewWithDataContext = () => useContext(PreviewWithDataContext);
